import { typedQueryClient, useTypedQuery } from "hooks";
import { IncompleteTyresQueryKeys } from "modules/IncompleteTyresDashboard/queryKeys";
import { INCOMPLETE_TYRES_STORAGE_KEYS } from "modules/IncompleteTyresDashboard/storageKeys";
import { PAGE_SIZE, getPreference, setPreference } from "utils/common";

import type { OnChangeFn, PaginationState } from "@tanstack/react-table";
import type { IncompleteTyresFilters } from "modules/IncompleteTyresDashboard/queryKeys";

const getDefaultFilters = (): IncompleteTyresFilters => ({
  page: 1,
  page_size: getPreference(INCOMPLETE_TYRES_STORAGE_KEYS.PageSizePreference, PAGE_SIZE.PageSize25)
});

export const useIncompleteTyresFilters = () => useTypedQuery({ queryKey: IncompleteTyresQueryKeys.filters, initialData: getDefaultFilters }).data;

export const setIncompleteTyresFilters = (newFilters: Partial<IncompleteTyresFilters>) =>
  typedQueryClient.setQueryData(IncompleteTyresQueryKeys.filters, prev => (prev ? { ...prev, ...newFilters } : prev));

export const handlePaginationChange: OnChangeFn<PaginationState> = updater =>
  typedQueryClient.setQueryData(IncompleteTyresQueryKeys.filters, prev => {
    if (!prev) return prev;

    const newState = typeof updater === "function" ? updater({ pageIndex: prev.page - 1, pageSize: prev.page_size }) : updater;
    if (newState.pageIndex + 1 === prev.page) return prev;

    return { ...prev, page: newState.pageIndex + 1 };
  });

export const handlePageSizeChange = (page_size: number) => {
  setPreference(INCOMPLETE_TYRES_STORAGE_KEYS.PageSizePreference, page_size);
  setIncompleteTyresFilters({ page_size, page: 1 });
};
